//console.log("1.0");

/* funcionalidad consultar via whatsapp */
document.addEventListener('DOMContentLoaded', function() {
    // Usar setTimeout para asegurar que el DOM está completamente cargado
    setTimeout(function() {
        var productTitleEl = document.querySelector("h1.product-title");
        var productName = productTitleEl ? productTitleEl.textContent.trim() : "";

    /* ============================================
     * FUNCIÓN DE CONSULTA POR WHATSAPP - COMENTADA
     * Para reactivar, descomentar el código siguiente
     * ============================================ */
    /*
    //$(".product-form--atc-button").removeClass("disabled");
    // Agregar estilos dinámicos con !important usando una hoja de estilos
    if (!$("#supps-disabled-button-styles").length) {
      $("<style id='supps-disabled-button-styles'>")
        .prop("type", "text/css")
        .html(".product-form--atc-button.disabled { background-color: #b0b0b0 !important; background: #b0b0b0 !important; border: 1px solid #b0b0b0 !important; border-color: #b0b0b0 !important; color: #000000 !important; } .product-form--atc-button.disabled .atc-button--text { color: #000000 !important; }")
        .appendTo("head");
    }
    
    function aplicarEstilosDisabled() {
      $(".product-form--atc-button.disabled").each(function() {
        var $btn = $(this);
        $btn.css("background-color","#b0b0b0");
        $btn.css("border","1px solid #b0b0b0");
        $btn.css("color","#000000");
        $btn.css("opacity","1");
      });
    }
    aplicarEstilosDisabled();
    // Re-aplicar después de un pequeño delay para asegurar que sobrescriba otros estilos
    setTimeout(aplicarEstilosDisabled, 100);
    setTimeout(aplicarEstilosDisabled, 500);
    $(".product-form--atc-button.disabled").removeAttr("disabled");
    $(".product-form--atc-button.disabled").click(function(){
        window.open("https://api.whatsapp.com/send/?phone=51971227771&text=Hola Music Market quiero consultar el stock de este producto '"+productName+"'&type=phone_number&app_absent=0");
    });
    $(".product-form--atc-button.disabled").hover(function(){
      $(this).css("cursor", "pointer");
    });
    */

    /* Calcular fecha de envío */
    function calcularFechaEnvio(diasHabiles) {
        var hoy = new Date();
        var diasAgregados = 0;
        var fechaEntrega = new Date(hoy);

        // Empieza desde mañana si es hoy
        fechaEntrega.setDate(hoy.getDate() + 1);

        while (diasAgregados < diasHabiles) {
            var diaSemana = fechaEntrega.getDay(); // 0 = Domingo, 6 = Sábado
            
            // Solo contar días hábiles (lunes a sábado: 1-6, excluyendo domingo: 0)
            if (diaSemana >= 1 && diaSemana <= 6) {
                diasAgregados++;
            }
            
            // Si aún no hemos agregado los días necesarios, avanzar al siguiente día
            if (diasAgregados < diasHabiles) {
                fechaEntrega.setDate(fechaEntrega.getDate() + 1);
            }
        }

        return fechaEntrega;
    }

    function formatearFechaEspanol(fecha) {
        var diasSemana = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
        var meses = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
        
        var diaSemana = diasSemana[fecha.getDay()];
        var dia = fecha.getDate();
        var mes = meses[fecha.getMonth()];
        
        return diaSemana + ' ' + dia + ' ' + mes;
    }

    /* 
    // Calcular y actualizar fecha de envío (4 días hábiles, lunes a sábado)
    var fechaEntrega = calcularFechaEnvio(2);
    var fechaFormateada = formatearFechaEspanol(fechaEntrega);

    var shippingDate = document.getElementById("shipping-date");
    if (shippingDate) {
        shippingDate.textContent = fechaFormateada;
    }
    */

    // Calcular y actualizar texto de envío para el segundo banner - Lógica basada en product-type
    var shippingBanner2 = document.querySelector(".shipping-banner-2");
    var productType = shippingBanner2 ? shippingBanner2.getAttribute("data-product-type") : "";
    var ahora = new Date();
    var horaActual = ahora.getHours();
    var textoEnvio = "";
    
    // Tipos que siempre muestran "mañana"
    var tiposProductos = [
        "productos", "producto",
        "guitarras", "guitarra",
        "pianos", "piano",
        "teclados", "teclado",
        "baterias", "bateria",
        "trompetas", "trompeta",
        "saxofones", "saxofon", "saxofón",
        "instrumentos de banda", "instrumento de banda",
        "timbales", "timbale",
        "congas", "conga",
        "tumbas quintos", "tumba quinto",
        "bongos", "bongo",
        "arregladores", "arreglador",
        "sintetizadores", "sintetizador"
    ];
    
    // Tipos que siguen la lógica de hora (accesorios, cuerdas, correas, soportes)
    var tiposAccesorios = ["accesorios", "accesorio", "cuerdas", "cuerda", "correas", "correa", "soportes", "soporte"];
    
    // Convertir productType a minúsculas para comparación
    productType = productType.toLowerCase().trim();
    
    // Verificar si es un tipo de producto (siempre mañana)
    var esProducto = tiposProductos.some(function(tipo) {
        return productType === tipo || productType.indexOf(tipo) !== -1;
    });
    
    // Verificar si es un tipo de accesorio (lógica de hora)
    var esAccesorio = tiposAccesorios.some(function(tipo) {
        return productType === tipo || productType.indexOf(tipo) !== -1;
    });
    
    if (esProducto) {
        // Si es producto, siempre mostrar "mañana"
        textoEnvio = "Se envía <strong>mañana</strong>";
    } else if (esAccesorio) {
        // Si es accesorio, aplicar lógica de hora
        if (horaActual < 12) {
            textoEnvio = "Se envía <strong>hoy</strong>";
        } else {
            textoEnvio = "Se envía <strong>mañana</strong>";
        }
    } else {
        // Por defecto, aplicar lógica de hora
        if (horaActual < 12) {
            textoEnvio = "Se envía <strong>hoy</strong>";
        } else {
            textoEnvio = "Se envía <strong>mañana</strong>";
        }
    }
    
    var shippingDate2 = document.getElementById("shipping-date-2");
    if (shippingDate2) {
        shippingDate2.innerHTML = textoEnvio;
        console.log("Texto de envío actualizado:", textoEnvio);
    } else {
        console.log("Elemento #shipping-date-2 no encontrado");
    }
    }, 500); // Esperar 500ms para que el DOM esté completamente cargado
});

/* ============================================
   CART DRAWER
   ============================================ */
(function () {
  var drawer, overlay, body, itemsEl, subtotalEl, countEl, footerEl, emptyEl, loadingEl;
  var moneyFormat = '{{ amount }}';
  var isUpdating = false;

  function init() {
    drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    moneyFormat = drawer.getAttribute('data-money-format') || '{{ amount }}';
    overlay    = drawer.querySelector('[data-cart-drawer-overlay]');
    body       = drawer.querySelector('[data-cart-drawer-body]');
    itemsEl    = drawer.querySelector('[data-cart-drawer-items]');
    subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    countEl    = drawer.querySelector('[data-cart-drawer-count]');
    footerEl   = drawer.querySelector('[data-cart-drawer-footer]');
    emptyEl    = drawer.querySelector('[data-cart-drawer-empty]');
    loadingEl  = drawer.querySelector('[data-cart-drawer-loading]');

    document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    overlay.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    document.addEventListener('cart:updated', function () {
      fetchAndRender();
      if (!drawer.classList.contains('is-open')) openDrawer();
    });

    // Interceptar botones ATC (grid y página de producto) para abrir el drawer
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-buy], [data-product-atc-custom]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      // Obtener variant ID: del atributo (grid) o del select del formulario (producto)
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        var form = btn.closest('form') || document.querySelector('[data-product-form]');
        var select = form && form.querySelector('[data-variants]');
        variantId = select ? select.value : null;
      }
      if (!variantId || variantId === 'not-selected') return;

      btn.classList.add('loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          btn.classList.remove('loading');
          btn.disabled = false;
        })
        .catch(function () {
          btn.classList.remove('loading');
          btn.disabled = false;
        });
    }, true); // capture: intercepta antes del handler de Empire

    // Checkout buttons: clear attributes then proceed
    drawer.querySelectorAll('.cart-drawer__actions form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var f = this;
        clearAttributesAndProceed(function () { f.submit(); });
      });
    });
  }

  function clearAttributesAndProceed(callback) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          UbigeoCode: '', Departamento: '', Provincia: '', Distrito: '',
          TipoDocumento: '', NumeroDocumento: '', Telefono: '+51',
          MetodoPago: '', Descuento: ''
        }
      })
    })
    .then(function () { callback(); })
    .catch(function () { callback(); });
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchAndRender();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function fetchAndRender() {
    showLoading();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(hideLoading);
  }

  function showLoading() {
    loadingEl.style.display = 'flex';
    itemsEl.style.display = 'none';
    emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'none';
  }

  function hideLoading() {
    loadingEl.style.display = 'none';
  }

  function renderCart(cart) {
    hideLoading();
    syncHeaderCount(cart.item_count);

    if (countEl) {
      countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    }

    if (cart.item_count === 0) {
      itemsEl.style.display = 'none';
      emptyEl.style.display = 'flex';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    emptyEl.style.display = 'none';
    itemsEl.style.display = 'block';
    if (footerEl) footerEl.style.display = 'block';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item) {
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__item-variant">' + escHtml(item.variant_title) + '</p>'
        : '';

      var imgSrc = item.image
        ? item.image.replace(/^http:/, 'https:').replace(/(\.[^.?]+)(\?.*)?$/, '_120x$1$2')
        : '';
      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + escHtml(item.product_title) + '" loading="lazy">'
        : '';

      return [
        '<li class="cart-drawer__item" data-item-key="' + item.key + '">',
          '<div class="cart-drawer__item-image">',
            '<a href="' + item.url + '">' + imgHtml + '</a>',
          '</div>',
          '<div class="cart-drawer__item-details">',
            '<h3 class="cart-drawer__item-title">',
              '<a href="' + item.url + '">' + escHtml(item.product_title) + '</a>',
            '</h3>',
            variantHtml,
            '<div class="cart-drawer__item-row">',
              '<div class="cart-drawer__item-qty">',
                '<button class="cart-drawer__item-qty-btn" type="button"',
                  ' data-qty-change="-1" data-item-key="' + item.key + '"',
                  ' aria-label="Disminuir cantidad">&#8722;</button>',
                '<span class="cart-drawer__item-qty-val">' + item.quantity + '</span>',
                '<button class="cart-drawer__item-qty-btn" type="button"',
                  ' data-qty-change="1" data-item-key="' + item.key + '"',
                  ' aria-label="Aumentar cantidad">+</button>',
              '</div>',
              '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>',
            '</div>',
            '<button class="cart-drawer__item-remove" type="button"',
              ' data-item-remove data-item-key="' + item.key + '">Eliminar</button>',
          '</div>',
        '</li>'
      ].join('');
    }).join('');

    bindItemEvents();
  }

  function bindItemEvents() {
    itemsEl.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (isUpdating) return;
        var key    = this.getAttribute('data-item-key');
        var change = parseInt(this.getAttribute('data-qty-change'), 10);
        var qtyEl  = this.closest('.cart-drawer__item-qty').querySelector('.cart-drawer__item-qty-val');
        var newQty = Math.max(0, parseInt(qtyEl.textContent, 10) + change);
        updateQty(key, newQty);
      });
    });

    itemsEl.querySelectorAll('[data-item-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (isUpdating) return;
        updateQty(this.getAttribute('data-item-key'), 0);
      });
    });
  }

  function updateQty(key, quantity) {
    isUpdating = true;
    body.classList.add('is-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        // Si Shopify rechaza (ej. sin stock), devuelve 422 — re-fetch estado real
        if (!r.ok) {
          return fetch('/cart.js').then(function (r2) { return r2.json(); });
        }
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        isUpdating = false;
        body.classList.remove('is-loading');
      })
      .catch(function () {
        // Si falla todo, re-fetch para mostrar estado actual
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(renderCart)
          .finally(function () {
            isUpdating = false;
            body.classList.remove('is-loading');
          });
      });
  }

  function syncHeaderCount(count) {
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      if (count > 0) {
        el.classList.add('visible');
        el.setAttribute('data-header-cart-count', count);
      } else {
        el.classList.remove('visible');
        el.setAttribute('data-header-cart-count', '');
      }
    });
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var amount    = (cents / 100).toFixed(2);
    var parts     = amount.split('.');
    parts[0]      = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimal = parts[0];
    var full      = parts.join('.');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, full)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimal)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, full.replace(',', '.').replace('.', ','));
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
